export default {
      id: "user_check-usage",
      viewBox: "0 0 26 19",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#user_check",
      toString: function () {
        return this.url;
      }
    }